var codes = require('country-codes-map.json');

var getLines = function(bridge, includePrimaryDid) {
	var bridgeLines = Object.keys(bridge).filter(function(prop) {
		// looks like bridge_number_1 and isn't null
		return /^bridge\_number\_\d+/.test(prop) && bridge[prop];
	}).map(function(prop){
		return bridge[prop];
	});

  var bridgeDids = (bridge.dids || []).filter(function(d) {
    return !d.deleted;
  });

	var primary = includePrimaryDid ? bridgeDids.filter(function(b) {
		return b.primary;
	}) : [];

	var dids = bridgeDids.filter(function(b) {
		return !b.primary;
	});

	return primary.concat(dids).concat(bridgeLines);
};

var getCode = function(line) {
	if(line && line.country_iso_code) {
		return line.country_iso_code;
	}

	return libphone.parse(line).country;
};

var getLineInfo = function(line) {
	if(!line) {
		return '';
	}

	if(typeof line !== 'string' && line && !line.country_dial_code) {
		line = line.number;
	}

	if(typeof line === 'string') {
		var country = libphone.parse(line).country,
			prefix = '';

		if(country && country+'' !== 'undefined') {
			try {
				prefix += '+'+libphone.getPhoneCode(country)+' ';
			} catch(e) {
				console.error('Invalid country', country, JSON.stringify(line));
			}
		}
    return libphone.format(line, 'International');
  }

  if (line.country_dial_code.toString() === '1') {
  	return '+'+line.country_dial_code+' '+libphone.format(line.number, line.country_iso_code, 'National');
  }

  return libphone.format(line.number, line.country_iso_code, 'International');
};

angular.module('bbl.directives.connected-lines', [])
.filter('bridge_number', [function() {
	return function(bridge) {
		return (bridge.dids||[]).filter(function(b) {
			return !b.deleted && b.primary;
		})[0];
	};
}])
.filter('cLines', [function() {
	return getLines;
}])
.filter('cLineIso', function() {
	return function(line) {
		if(line && line.country_iso_code) {
			return line.country_iso_code;
		}

		return libphone.parse(line).country;
	};
})
.filter('cLineCountry', function() {
	return function(line) {
		var code = getCode(line);
		return code && codes[code];
	};
})
.filter('cLineFm', function() {
	return function(line, showIso) {
		return (showIso === true && getCode(line) ? getCode(line)+': ' : '') + getLineInfo(line);
	};
})
.filter('cLinesHtm', ['$filter', function($filter) {
	return function(lines, separator) {
		return lines.map(function(l) {
			return $filter('cLineFm')(l);
		}).join(separator||'<br>');
	};
}])
.filter('cLinesClip', [function() {
	return function(bridge, screenshareLink) {
		var lines = getLines(bridge, true).map(function(line) {
			var number = getLineInfo(line),
				code = getCode(line);

			if(code && codes[code]) {
				number = codes[code]+': '+number;
			}

			return number;
		}).join('\n');

    if(bridge.attendee_PIN && bridge.attended) {
      lines += '\nAttendee Pin: '+bridge.attendee_PIN;
    }

    var primaryLine = getLines(bridge, true).find(function(d) {return d.primary;});
    if (primaryLine) {
      var dialIn = '\nOne-touch phone link: tel:'+(primaryLine.number || '').replace(/^\+/, '');
      if(bridge.attendee_PIN && bridge.attended) {
        dialIn += ',,'+bridge.attendee_PIN+'#';
      }
      lines += dialIn;
    }

    lines += '\nJoin from browser link: '+screenshareLink;

		return lines;
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/connected-lines.js
 ** module id = 166
 ** module chunks = 0
 **/